import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'
import withRouterLegacy from 'withRouterLegacy'
import api from 'api'
import {actionCreators} from 'actions'
import {Log} from 'settings/auditLogs/Show'

class Show extends Component {
  componentDidMount() {
    const {
      token,
      match: {
        params: {log_id: id},
      },
      loadData,
    } = this.props
    loadData(token, id)
  }

  componentWillUnmount() {
    this.props.destroy()
  }

  render() {
    const {
      log,
      match: {
        params: {id},
      },
    } = this.props
    return (
      <div>
        <div className="l-main-title-wrap">
          <h1 className="m-title-main">操作履歴</h1>
        </div>
        <div className="l-wrap-s l-contents-wrap">
          <div className="l-breadcrumb u-mb20">
            <Link to="/employees" className="l-breadcrumb-link">
              従業員一覧
            </Link>
            <Link to={`/employees/${id}`} className="l-breadcrumb-link">
              従業員情報
            </Link>
            <Link to={`/employees/${id}/audit_logs`} className="l-breadcrumb-link">
              操作履歴
            </Link>
            <span className="l-breadcrumb-here">操作履歴詳細</span>
          </div>
          <Log log={log} />
        </div>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    log: state.settings.auditLogs.current.data,
    token: state.auth.token,
  }),
  (dispatch) => ({
    loadData(token, id) {
      dispatch(actionCreators.settings.auditLogs.current.fetchData(api.createWithAuth(token).auditLogs.get(id)))
    },
    destroy() {
      dispatch(actionCreators.settings.auditLogs.current.destroy())
    },
  })
)(withRouterLegacy(Show))
